export default {
      id: "Icon--audioMissing-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--audioMissing",
      toString: function () {
        return this.url;
      }
    }